import { useMemo } from 'react';

import { GridColDef } from '@mui/x-data-grid-pro';

import { BrandNameAndImageCell } from '../shared/components';
import { BrandRow } from '../shared/types';

import { ConnectionStatusCell } from './components/connection-status-cell';

export const useColumns = () => {
  return useMemo(
    (): GridColDef<BrandRow>[] => [
      {
        field: 'name',
        headerName: 'Brand',
        flex: 1,
        renderCell: BrandNameAndImageCell,
      },
      {
        field: 'connectionStatus',
        headerName: 'Brand Connection Status',
        flex: 1,
        renderCell: ConnectionStatusCell,
      },
    ],
    [],
  );
};
